import React, { Fragment } from "react";
import {
  isContentGroup,
  isContentGroupsHome,
  OrganizeViews,
} from "../organizeUtil";
import { equals } from "ramda";

import ModulesPanel from "./ModulesPanel";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

import Divider from "@material-ui/core/Divider";

const OrganizeContentGroupsBrowser = props => {
  const { filesPanel, header, contentGroupsPanel, loading, view } = props;

  return loading ? (
    <PanelLoadingIndicator />
  ) : (
    <Fragment>
      {header}
      {isContentGroup(view) && <Divider />}
      {isContentGroupsHome(view) && <ModulesPanel />}
      {!equals(view, OrganizeViews.COLLECTION) && contentGroupsPanel}
      {filesPanel}
    </Fragment>
  );
};

export default OrganizeContentGroupsBrowser;
